/* HomLoom creative cart drawer - behaviour (all prices come live from Shopify) */
(function () {
if (window.__hlCart) return;
window.__hlCart = true;
var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var FMT = window.hlMoneyFormat || 'Dhs. {{amount}}';
function money(cents) {
cents = Number(cents) || 0;
function fmt(n, d) { var p = (n / 100).toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return p.join('.'); }
return FMT.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
if (k === 'amount_no_decimals') return fmt(cents, 0);
if (k === 'amount_with_comma_separator') return fmt(cents, 2).replace('.', ',');
return fmt(cents, 2);
});
}
function drawer() { return document.getElementById('CartDrawer'); }
function busy(on) { var d = drawer(); if (d) d.classList.toggle('hl-busy', !!on); }
function toast(msg) {
var inner = document.querySelector('#CartDrawer .drawer__inner');
if (!inner) return;
var t = inner.querySelector('.hl-toast');
if (!t) { t = document.createElement('div'); t.className = 'hl-toast'; inner.appendChild(t); }
t.textContent = msg; t.classList.add('is-on');
clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
}
var nativeFetch = window.fetch.bind(window);
function post(url, body) {
return nativeFetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
.then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
}
function refresh() {
return nativeFetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (data) {
var p = new DOMParser();
if (data['cart-drawer']) {
var doc = p.parseFromString(data['cart-drawer'], 'text/html');
var ni = doc.querySelector('.drawer__inner'), ci = document.querySelector('#CartDrawer .drawer__inner');
if (ni && ci) ci.innerHTML = ni.innerHTML;
var nd = doc.querySelector('cart-drawer'), cd = document.querySelector('cart-drawer');
if (nd && cd) cd.classList.toggle('is-empty', nd.classList.contains('is-empty'));
}
if (data['cart-icon-bubble']) {
var b = document.getElementById('cart-icon-bubble');
var nb = p.parseFromString(data['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
if (b && nb) b.innerHTML = nb.innerHTML;
}
init();
});
}
window.hlCartRefresh = refresh;
var lastAddClick = 0;
document.addEventListener('click', function (e) {
var b = e.target.closest('button, a, input[type="submit"], [role="button"]');
if (!b || b.closest('#CartDrawer')) return;
var txt = ((b.textContent || b.value || '') + '').toLowerCase();
if (/order now|cash on delivery|cod/.test(txt)) { lastAddClick = 0; return; }
if (b.name === 'add' || /add to cart|add to bag/.test(txt)) lastAddClick = Date.now();
}, true);
function afterAdd() {
if (!lastAddClick || Date.now() - lastAddClick > 8000) return;
lastAddClick = 0;
setTimeout(function () {
refresh().then(function () {
var cd = document.querySelector('cart-drawer');
if (cd && !cd.classList.contains('active') && typeof cd.open === 'function') cd.open();
});
}, 200);
}
window.fetch = function (input) {
var u = (typeof input === 'string' ? input : (input && input.url)) || '';
var pr = nativeFetch.apply(window, arguments);
if (/\/cart\/add/.test(u)) pr.then(function (r) { if (r && r.ok) afterAdd(); }).catch(function () {});
return pr;
};
try {
var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.open = function (m, u) { this.__hlu = u; return xo.apply(this, arguments); };
XMLHttpRequest.prototype.send = function () {
var x = this;
if (/\/cart\/add/.test(String(x.__hlu || ''))) x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) afterAdd(); });
return xs.apply(this, arguments);
};
} catch (x) {}
function currentCodes() {
return Array.prototype.map.call(document.querySelectorAll('#CartDrawer [data-hl-code]'), function (e) { return e.getAttribute('data-hl-code'); });
}
function codeOk(cart, code) {
return (cart.discount_codes || []).some(function (d) { return d.code.toUpperCase() === code.toUpperCase() && d.applicable; });
}
function setCodes(list) {
var clean = list.filter(function (c, i) { return c && list.indexOf(c) === i; });
return post('cart/update.js', { discount: clean.join(',') });
}
document.addEventListener('click', function (e) {
var t = e.target.closest('[data-hl-action]');
if (!t || !t.closest('#CartDrawer')) return;
e.preventDefault();
var a = t.getAttribute('data-hl-action'), job;
busy(true);
if (a === 'set-qty') {
job = post('cart/change.js', { id: t.getAttribute('data-key'), quantity: Number(t.getAttribute('data-qty')) })
.then(function () { return refresh(); }).then(function () { toast('Added to your cart ✓'); });
} else if (a === 'add-variant') {
job = post('cart/add.js', { items: [{ id: Number(t.getAttribute('data-id')), quantity: 1 }] })
.then(function () { return refresh(); }).then(function () { toast('Added to your cart ✓'); });
} else if (a === 'apply-code') {
var code = t.getAttribute('data-code');
var keep = currentCodes().filter(function (c) { return !/^HOLIDAYBUNDLE/i.test(c); });
job = setCodes(keep.concat([code])).then(function (cart) {
if (!codeOk(cart, code)) {
return setCodes(keep).then(function () { return refresh(); }).then(function () { toast("This offer can't be combined with your current deal"); });
}
return refresh().then(function () { toast(code + ' applied ✓'); });
});
} else if (a === 'remove-code') {
var rm = (t.getAttribute('data-code') || '').toUpperCase();
job = setCodes(currentCodes().filter(function (c) { return c.toUpperCase() !== rm; })).then(function () { return refresh(); });
}
if (job) {
job.catch(function (err) { toast((err && (err.description || err.message)) || 'Something went wrong - please try again'); })
.then(function () { busy(false); });
} else busy(false);
});
document.addEventListener('submit', function (e) {
var f = e.target.closest('form[data-hl-promo]');
if (!f) return;
e.preventDefault();
var input = f.querySelector('input');
var err = f.parentNode.querySelector('[data-hl-promo-err]');
var code = (input.value || '').trim();
if (!code) { if (err) { err.textContent = 'Please enter a code'; err.hidden = false; } return; }
busy(true);
var before = currentCodes();
setCodes(before.concat([code])).then(function (cart) {
if (!codeOk(cart, code)) {
return setCodes(before).then(function () { return refresh(); }).then(function () { toast("This code can't be used on your cart"); });
}
return refresh().then(function () { toast(code.toUpperCase() + ' applied ✓'); });
}).catch(function () { toast('Could not apply code'); }).then(function () { busy(false); });
});
function eta() {
document.querySelectorAll('#CartDrawer [data-hl-journey]').forEach(function (el) {
var min = Number(el.getAttribute('data-min')) || 1, max = Number(el.getAttribute('data-max')) || 3, now = Date.now();
function f(d) {
try { return new Date(now + d * 864e5).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Asia/Dubai' }); }
catch (x) { return ''; }
}
var out = el.querySelector('[data-hl-eta]'), a = f(min), b = f(max);
if (out && a && b) out.textContent = (min === max) ? a : a + ' – ' + b;
});
}
/* #4 related products: curated list first (snippets/hl-related-map.liquid), Shopify recommendations as backup */
var recoCache = {};
function getProduct(h) {
return nativeFetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
}
function getRecos(pid) {
return Promise.all(['complementary', 'related'].map(function (intent) {
return nativeFetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + intent)
.then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; });
})).then(function (res) { return res.reduce(function (a, r) { return a.concat(r.products || []); }, []); });
}
function loadRecos() {
document.querySelectorAll('#CartDrawer [data-hl-recos]').forEach(function (el) {
if (el.getAttribute('data-loaded')) return;
el.setAttribute('data-loaded', '1');
var pid = el.getAttribute('data-product-id');
var rel = (el.getAttribute('data-related') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
var ex = (el.getAttribute('data-exclude') || '').split(',');
var key = pid + '|' + rel.join(',');
var get = recoCache[key] || (recoCache[key] = Promise.all(rel.map(getProduct)).then(function (cur) {
cur = cur.filter(Boolean);
return cur.length >= 2 ? cur : getRecos(pid).then(function (more) { return cur.concat(more); });
}));
get.then(function (all) {
var seen = {}, list = [];
all.forEach(function (p) {
if (!p || seen[p.id] || ex.indexOf(p.handle) > -1 || !p.available) return;
seen[p.id] = 1; list.push(p);
});
list = list.slice(0, 4);
if (!list.length) return;
var row = el.querySelector('[data-hl-recos-row]');
row.innerHTML = list.map(function (p) {
var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
var img = p.featured_image || '';
if (img && typeof img === 'object') img = img.src || '';
if (img.indexOf('//') === 0) img = 'https:' + img;
if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
var price = v ? v.price : p.price, cap = v ? v.compare_at_price : p.compare_at_price;
return '<div class="hl-reco">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="132" height="132">' : '') +
'<p class="hl-reco__t">' + p.title.replace(/</g, '&lt;') + '</p>' +
'<p class="hl-reco__p">' + money(price) + (cap && cap > price ? '<s>' + money(cap) + '</s>' : '') + '</p>' +
'<button type="button" class="hl-reco__b" data-hl-action="add-variant" data-id="' + v.id + '">+ Add</button></div>';
}).join('');
el.classList.add('is-ready');
});
});
}
function shine() {
var b = document.getElementById('CartDrawer-Checkout');
if (b && !b.querySelector('.hl-shine')) { var s = document.createElement('span'); s.className = 'hl-shine'; b.appendChild(s); }
}
function init() { eta(); loadRecos(); shine(); }
var timer, syncing = false;
function syncCheck() {
if (syncing) return;
var j = document.querySelector('#CartDrawer [data-hl-sig]');
var s = document.querySelector('#CartDrawer .hl-summary[data-hl-sig]');
syncing = true;
nativeFetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
var live = c.item_count + '-' + c.total_price;
var stale = (j && j.getAttribute('data-hl-sig') !== live) || (s && s.getAttribute('data-hl-sig') !== live);
if (stale) return refresh();
}).catch(function () {}).then(function () { setTimeout(function () { syncing = false; }, 300); });
}
var mo = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(function () { init(); syncCheck(); }, 120); });
try {
var st = document.createElement('style');
st.textContent = 'body:has(cart-drawer.active) #hl-wa-tab{opacity:0!important;pointer-events:none!important}';
document.head.appendChild(st);
} catch (x) {}
function boot() { init(); var d = drawer(); if (d) mo.observe(d, { childList: true, subtree: true }); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();